import { __assign, __rest } from "tslib";
import React from 'react';
import s from './VisuallyHidden.scss';
/*
  Sometimes we need to include elements for accessibility reasons
  but design doesn't like those elements. So we use this component to
  make the element accessible to a screen reader, but hidden visually.
*/
var VisuallyHidden = function (_a) {
    var _b = _a.tag, tag = _b === void 0 ? 'span' : _b, children = _a.children, rest = __rest(_a, ["tag", "children"]);
    var Component = tag;
    return (React.createElement(Component, __assign({ className: s['root'] }, rest), children));
};
VisuallyHidden.displayName = 'VisuallyHidden';
export default VisuallyHidden;
//# sourceMappingURL=VisuallyHidden.js.map